import { CircleCloseIcon } from 'assets/icons';
import { CustomButton, CustomInput, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { InputType } from 'components/custom-input.tsx/CustomInput';
import React, { useState } from 'react';
import { TeamView } from 'containers/dispatch/dispatch.model';

interface CreateViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (viewName: string, parentView?: TeamView) => void;
  isSaving: boolean;
  isDuplicate?: boolean;
  parentViewName?: string;
}

const CreateViewModal: React.FC<CreateViewModalProps> = ({
  isOpen,
  onClose,
  onSave,
  isSaving,
  isDuplicate,
  parentViewName
}) => {
  const [viewName, setViewName] = useState(parentViewName ? parentViewName + ' (1)' : '');

  const handleSave = () => {
    onSave(viewName.trim());
  };

  return (
    <CustomModal
      className="md:w-[471px]"
      open={isOpen}
      closeModal={onClose}
      borderRadius="rounded-lg"
      backgroundColor="bg-white">
      <div className="p-6">
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-xl font-bold">{isDuplicate ? 'Duplicate view' : 'Create new view'}</h2>
          <CircleCloseIcon onClick={onClose} className="shrink-0 cursor-pointer" />
        </div>
        <CustomInput
          id="view-name-input"
          type={InputType.TEXT}
          placeholder="Enter view name"
          value={viewName}
          onChange={setViewName}
          label="View name"
          isMandatory={true}
          className="mb-4"
          labelClassName="text-17px"
        />
        <div className="flex justify-end gap-4">
          <CustomButton id="cancel-button" type={ButtonType.SECONDARY} onClick={onClose} className="h-10 w-[100px]">
            Cancel
          </CustomButton>
          <CustomButton
            id="save-button"
            type={ButtonType.PRIMARY}
            onClick={handleSave}
            className="h-10 w-[100px]"
            isLoading={isSaving}>
            Save
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default CreateViewModal;
